export * from './types';
export { MockEngine, mockEngine } from './MockEngine';
export { PluggableEngine, pluggableEngine } from './PluggableEngine';

import { isContextAvailable } from '@/miniappContext';

import { mockEngine } from './MockEngine';
import { pluggableEngine } from './PluggableEngine';
import type { GenerationEngine } from './types';

/**
 * Get the appropriate generation engine based on environment
 * Uses PluggableEngine in Picsart Editor, MockEngine otherwise
 */
export const getGenerationEngine = (): GenerationEngine => {
  if (isContextAvailable()) {
    return pluggableEngine;
  }
  return mockEngine;
};

export const createGenerationEngine = async (): Promise<GenerationEngine> => {
  const engine = getGenerationEngine();
  const isAvailable = await engine.isAvailable();

  if (isAvailable) {
    return engine;
  }

  return mockEngine;
};
